import { useEffect, useState } from "react"
import '../dashboard.css'
import axios from "axios";

export default function Dashboard() {

    const dashboardData = {
        summary: {
            total: 28,
            completed: 12,
            in_progress: 9,
            waiting: 7
        },

        pipeline: {
            triage: 14,
            payment: 10,
            mri: 6,
            completed: 12
        },

        bottleneck: {
            waiting_mri: 6,
            longest_wait: "42 min"
        },

        activity: [
            { event: "Patient Abel registered", time: "10:12" },
            { event: "Payment completed (Selam)", time: "10:18" },
            { event: "MRI started (Kebede)", time: "10:25" },
            { event: "MRI completed (Sara)", time: "10:40" },
            { event: "Patient Hana registered", time: "10:45" }
        ]
    };
    const [data, setData] = useState(null)
    function Card({ title, value }) {
        return <div className="card">
            <p>{title}</p>
            <h3>{value}</h3>
        </div>
    }
    useEffect(() => {
        document.querySelector(".dashboard-link")?.classList.toggle('on', true)
        axios.get(`${process.env.REACT_APP_API_URL}/dashboard/summary`).then(res => {
            console.log(res.data)
            setData(res.data)
            console.log(res.data.activity)
        })
        console.log("dash effect")
    }, [])
    return (
        <>
            <div className="dashboard-container">
                {data?.summary && (
                    <>
                        <h2>Summary</h2>
                        <div className="summary-grid">
                            <Card title="Total Patients" value={data.summary.total} />
                            <Card title="Today's Patients" value={data.summary.today_patients} />
                            <Card title="Completed" value={data.summary.completed.length} />
                            <Card title="In Progress" value={data.summary.in_progress.length} />

                        </div>
                    </>
                )
                }
                <hr />
                {data?.pipeline && (
                    <>
                        <h2>Workflow Pipeline</h2>

                        <div className="pipeline">
                            <div>Registered: {data.pipeline.triage.length}</div>
                            <div>→</div>
                            <div>Paid: {data.pipeline.payment.length}</div>
                            <div>→</div>
                            <div>Waiting: {data.pipeline.mri.length}</div>
                            <div>→</div>
                            <div>Completed: {data.pipeline.completed.length}</div>
                        </div>
                    </>)}
                <hr />
                <h2>Scan Insights</h2>
                <div>
                    Coming Soon
                </div>
                <hr />
                {data?.bottleneck && (
                    <>
                        <h2>Bottleneck Alerts [Demo]</h2>
                        <div className="alert-box">
                            <p>⚠ {data.pipeline.mri.length} patients waiting for MRI</p>
                            <p>⏱ Longest wait: {data.bottleneck.longest_wait}</p>
                        </div>
                    </>
                )}
                <hr />
                {data?.activity && (
                    <>
                        <h2>Recent Activity [Demo]</h2>
                        <div className="activity">
                            {
                                data.activity.map((item, i) => {
                                    return <p key={i}>{item.event} {item.time}</p>
                                })
                            }
                        </div>
                    </>
                )}

            </div>
        </>)
}